import * as React from 'react';

export const Header: React.FC<{
  isLoading: boolean;
  isListOfLabels: boolean;
  itemCount?: number;
  labelQuantity?: number;
  itemDescription?: string;
}> = ({ isLoading, isListOfLabels, itemDescription, itemCount, labelQuantity }) => {
  if (isLoading) {
    return <span key="localizejs-fix">Print label</span>;
  }
  if (isListOfLabels) {
    return (
      <span key="localizejs-fix">
        Print label queue - <var>{itemCount}</var> items, <var>{labelQuantity} </var>labels
      </span>
    );
  }
  return (
    <span key="localizejs-fix">
      Print label for <var>{itemDescription}</var>
    </span>
  );
};
